<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <form novalidate @submit.prevent="submit"> 

          <Input 
            type="text" 
            @on-input="emailInput" 
            :isError="invalidValue(emailError)"
            :textError="errorTextEmail"
            caption="Email:"
            :success="emailIsCorrect"
            :maxLength="255"
          />

          <Input 
            type="text" 
            @on-input="nameInput" 
            :isError="invalidValue(nameError)"
            :textError="errorTextName"
            caption="Отображаемое имя:"
            :maxLength="255"
          />

          <Input 
            type="password" 
            @on-input="passInput" 
            caption="Пароль:"
            :isError="invalidValue(passError)"
            :textError="errorTextPass"
            :maxLength="32"
          />

          <Input 
            type="password" 
            @on-input="confirmPassInput" 
            caption="Подтверждение пароля:"
            :success="confPassIsCorrect"
          />

          <div class="form-group text-center">
            <router-link :to="{ name: 'Login' }" class="d-inline"> Войти </router-link> | 
            <router-link :to="{ name: 'ResetPassword' }" class="d-inline"> Забыли пароль? </router-link>
          </div>
              
          <button class="btn btn-primary" type="button" disabled v-if="showWait">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Загрузка...
          </button>
          <button type="submit" class="btn btn-primary" v-else>
            Зарегистрироваться
          </button>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Input.vue'
import { minLength, testEmail } from '@/utils/Validate.js'

export default {
  components: {
    Input
  },
  data() {
    return {
      email: '',
      emailIsCorrect: false,
      emailError: {
        minLength: false,
        wrongEmail: false,
        existsEmail: false
      },
      pass: '',
      passError: {
        minLength: false,
        wrongPass: false,
      },
      confirmPass: '',
      confPassIsCorrect: false,
      showWait: false,
      name: '',
      nameError: {
        minLength: false
      }
    }
  },
  computed: {
    errorTextEmail: function() {
      let error = "";
      if (this.emailError.minLength) error = "Поле email не должно быть пустым!"
      if (this.emailError.existsEmail) error = "Указанный email уже зарегистрирован!"
      if (this.emailError.wrongEmail) error = "Введите корректный email!"
      return error;
    },
    errorTextPass: function() {
      let error = "";
      if (this.passError.minLength) error = "Поле пароль не должно быть менее 4-х символов!"
      if (this.passError.wrongPass) error = "Пароль и подтверждение не совпадают! "
      return error;
    },
    errorTextName() {
      let error = "";
      if (this.nameError.minLength) error = "Поле имя не должно быть пустым!";
      return error;
    },
  },
  methods: {
    emailInput(value) {
      this.emailError.minLength = minLength(value)
      this.emailError.existsEmail = false
      this.emailError.wrongEmail = false
      this.emailIsCorrect = testEmail(value)
      this.email = value
    },
    passInput(value) {
      this.passError.minLength = minLength(value)
      this.passError.wrongPass = false
      this.pass = value
      this.confPassIsCorrect = (this.pass === this.confirmPass && !minLength(this.pass))
    },
    confirmPassInput(value) {
      this.passError.wrongPass = false
      this.confirmPass = value
      this.confPassIsCorrect = (this.pass === this.confirmPass && !minLength(this.pass))
    },
    nameInput(value) {
      this.nameError.minLength = minLength(value)
      this.name = value
    },
    invalidValue(obj) {           // Проверяем значение на ошибки
      for (let key in obj) {
        if (obj[key]) return true
      }
      return false
    },
    submit() {
      this.emailError.minLength = minLength(this.email)
      this.emailError.wrongEmail = !testEmail(this.email)
      this.passError.minLength = minLength(this.pass)
      this.passError.wrongPass = (this.pass !== this.confirmPass)
      this.nameError.minLength = minLength(this.name)

      if (!this.invalidValue(this.emailError) && !this.invalidValue(this.passError) && !this.invalidValue(this.nameError)) {
        // submit
        this.showWait = true
        const formData = JSON.stringify({ name: this.name, password: this.pass, email: this.email })

        this.$store.dispatch('registrationUser', formData) 
        .then((res) => {
          this.showWait = false
          if (res.success) {
            // если регистрация успешна, сразу входим в систему
            const data = new FormData();
            data.append('email', this.email)
            data.append('pass', this.pass)

            this.$store.dispatch('loginUserWithPass', data)
          } else if (res.error === 'badPassword') this.passError.minLength = true
          else if (res.error === 'emailExists') {
            this.emailIsCorrect = false
            this.emailError.existsEmail = true
          }
        })
        .catch(() => {
          this.showWait = false
        })
      }
    }
  }
}
</script>